import * as Yup from 'yup'

const Validation = Yup.object().shape({
  comment: Yup.string(),
})

export default Validation
